import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import * as header from "./header.module.css"

import Button from "./button"
import { ArrowUpRight, Menu, X } from "react-feather"
import { useState, useEffect } from "react"

const Header = () => {
  const [mobileNav, setMobileNav] = useState(false)
  const [mobileDropdown, setMobileDropdown] = useState(null)

  const [links, setLinks] = useState([
    {
      title: "About",
      link: "/",
      sublinks: [
        {
          title: `What is SIGCHI?`,
          link: "/about",
        },
        {
          title: `Ethics and Conduct`,
          link: "/about/ethics-and-conduct",
        },
        {
          title: `Policies`,
          link: "/about/sigchi-policies",
        },
        {
          title: `CARES`,
          link: "/about/sigchi-cares",
        },
        {
          title: `Voting History`,
          link: "/about/voting-history",
        },
        {
          title: `Contact Us`,
          link: "/contact",
        },
      ],
    },
    {
      title: "People",
      link: "/",
      sublinks: [
        {
          title: `Membership`,
          link: "/people/membership",
        },
        {
          title: `Executive Committee`,
          link: "/people/executive-committee",
        },
        {
          title: `All Committees`,
          link: "/people/all-committees",
        },
        {
          title: `Chapters`,
          link: "/people/chapters",
        },
        {
          title: `Awards`,
          link: "/people/sigchi-awards",
        },
        {
          title: `Volunteer History`,
          link: "/people/volunteer-history",
        },
      ],
    },
    {
      title: "Conferences",
      link: "/",
      sublinks: [
        {
          title: `Upcoming Conferences`,
          link: "/conferences/upcoming",
        },
        {
          title: `Conference History`,
          link: "/conferences/history",
        },
        {
          title: `Publications`,
          link: "https://dl.acm.org/sig/sigchi",
        },
      ],
    },
    {
      title: "Resources",
      link: "/",
      sublinks: [
        {
          title: `Open Calls`,
          link: "https://sigchi.submittable.com/submit",
        },
        {
          title: `Development Fund`,
          link: "/resources/sigchi-development-fund",
        },
        {
          title: `Gary Marsden Travel Awards`,
          link: "/resources/gary-marsden-travel-awards",
        },
        {
          title: `Guides for Authors`,
          link: "/resources/guides-for-authors",
        },
        {
          title: `Guides for Organizers`,
          link: "/resources/guides-for-organizers",
        },
      ],
    },
    {
      title: "News",
      link: "/",
      sublinks: [
        {
          title: `Blog`,
          link: "https://medium.com/sigchi",
        },
        {
          title: `Meetings`,
          link: "/news/meetings/calendar",
        },
        {
          title: 'Announcements',
          link: "/news/announcements",
        },
        {
          title: 'Newsletters',
          link: "/news/newsletters",
        },
        {
          title: `YouTube`,
          link: "https://www.youtube.com/user/acmsigchi",
        },
      ],
    },
  ])

  return (
    <>
      <header className={`${header.primary} ${header.fixed}`}>
        <div className={`content ${header.headerContent}`} aria-label={`SIGCHI logo`}>
          <Link to="/">
            <StaticImage
              src="../images/logo-rgb.png"
              loading="eager"
              height={36}
              quality={95}
              formats={["auto", "webp", "avif"]}
              alt="SIGCHI Logo"
            />
          </Link>
          <div className={header.linksWrapper}>
            {links.map((l, index) => (
              <div className={header.linkAndDrop} key={index}>
                {/* <Link to={l.link}> */}
                  <div className={header.link} aria-label={`Header link`}>{l.title}</div>
                {/* </Link> */}
                {l.sublinks?.length > 0 ? (
                  <div className={header.dropDown}>
                    {l.sublinks.map((s, i) => (
                      <Link to={s.link}>
                        <div className={header.option} aria-label={`Sub-link under ${l.title}`}>{s.title}</div>
                      </Link>
                    ))}
                  </div>
                ) : null}
              </div>
            ))}
          </div>
          <div className={header.buttonWrapper}>
            <Link to={`https://sigchi.submittable.com/submit`}>
              <Button title={`Join Us`} icon={<ArrowUpRight />} />
            </Link>
          </div>
          <div
            className={header.menuWrapper}
            onClick={() => {
              setMobileNav(!mobileNav)
            }}
            aria-label={`Hamburger menu`}
            aria-roledescription={`${mobileNav ? "Close" : "Open"} navigation menu`}
          >
            <div className={header.menuIcon}>
              <div
                className={`${header.container} ${mobileNav && header.close}`}
              >
                <Menu /> <X />
              </div>
            </div>
            <p>{mobileNav ? "Close" : "Menu"}</p>
          </div>
        </div>
      </header>
      <nav className={`${header.mobile} ${mobileNav && header.navOpen}`}>
        <div className={header.mobileLinks}>
          {links.map((l, index) => (
            <div className={header.mobileLinkAndDrop} key={index}>
              <div
                className={`${header.mobileLink} ${
                  mobileDropdown === l.title && header.linkOpen
                }`}
                onClick={() => {
                  setMobileDropdown(l.title)
                }}
                aria-label={`Navigation link`}
              >
                {l.title}
              </div>
              <div
                className={`${header.mobileDrop} ${
                  mobileDropdown === l.title && header.dropOpen
                }`}
              >
                {l.sublinks.map((s, i) => (
                  <Link to={s.link} key={i}>
                    <div className={header.mobileOption} aria-label={`Sublink under ${l.title}`}>{s.title}</div>
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </nav>
    </>
  )
}

export default Header
